import langData from './en-US.json'
const locaLangData = {
  login: {
    readMarketing:
      'I agree to receive relevant SGS updates and invitations to events in accordance with',
    readMarketingAfter: '.',
    agreedBtn: 'I have read and agreed to the above',
    title: 'Sign in',
    loginFailed: 'loginFailed',
    info: 'Micro service Development Platform',
    tenantId: 'Please input tenantId',
    username: 'Please enter the registration email or mobile',
    password: 'Please enter the password',
    rePassword: 'Please enter the password again',
    passwordValidate: {
      lengthValidate: 'The minimum password length is 6 digits',
    },
    toRegister: 'Sign up',
    forgetPassword: 'Forgot password?',
    wechat: 'Wechat',
    needInvidUpdate: '',
    qq: 'QQ',
    phone: 'Please enter a phone number',
    code: 'Please input a code',
    submit: 'Sign in',
    userLogin: 'UserLogin',
    phoneLogin: 'PhoneLogin',
    thirdLogin: 'ThirdLogin',
    msgText: 'Send Code',
    msgSuccess: 'Reissued Code',
    readAgree: 'I have read and agree to ',
    serviceTrems: 'SGS Terms of Use',
    serviceTremsEnd: '.',
    agreeServiceTerms:
      'Please read and agree with SGS Service Terms & Conditions and Privacy Policy',
  },
  agreement: {
    agreeAndContinue: 'Agree and continue',
    privacyPolicy: 'SGS SMART Privacy Notice',
    useConditions: 'TERMS AND CONDITIONS OF USE',
  },
}
export default { ...locaLangData, ...langData } as Record<string, any>
